/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Volume_MediumInputs */

const en_us2_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medium`)
};

const pt_br2_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

const es_419_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

const pt_pt2_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médio`)
};

const fr_fr2_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moyen`)
};

const de_de2_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittel`)
};

const it_it2_workout_logging_volume_medium = /** @type {(inputs: Workout_Logging_Volume_MediumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medio`)
};

/**
* | output |
* | --- |
* | "Medium" |
*
* @param {Workout_Logging_Volume_MediumInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_volume_medium = /** @type {((inputs?: Workout_Logging_Volume_MediumInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Volume_MediumInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_volume_medium(inputs)
	if (locale === "es-419") return es_419_workout_logging_volume_medium(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_volume_medium(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_volume_medium(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_volume_medium(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_volume_medium(inputs)
	return en_us2_workout_logging_volume_medium(inputs)
});
export { workout_logging_volume_medium as "workout-logging.volume_medium" }